import { BaseHttpController } from '@Core/controller/BaseHttpController';
import { AxiosInstance } from 'axios';
import { GeoZones } from '../../model';
import { IAssignGeoZonesToGroupProps, IUnAssignGeoZonesFromGroupProps } from '../IGeoZoneGroupAssignmentHttpController';


export class GeoZoneGroupAssignmentHttpController extends BaseHttpController<{}>   {
    constructor(serviceUrl: string, client: AxiosInstance) {
        super(serviceUrl, 'geo-zone-group-assignment', client);
    }

    async assignGeoZoneToGroup(props: IAssignGeoZonesToGroupProps): Promise<GeoZones[]> {
        return await this.doPost({ path: `assign-geo-zones-to-group`, body: props}).then((res) => res.data);
    }

    async unAssignGeoZonesFromGroup(props: IUnAssignGeoZonesFromGroupProps): Promise<boolean> {
        return await this.doPost({ path: `un-assign-geo-zones-from-group`, body: props}).then((res) => res.data);
    }
}
